import React from 'react'

const Bookings = () => {
  return (
    <div >Bookings</div>
  )
}

export default Bookings